import Swal from 'sweetalert2';
import MD5 from "crypto-js/md5";
export const isObjEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

export const objectToQueryString = (obj: Object) => {
  return Object.entries(obj)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
}
// drop empty filter values (e.g. All on Aggregate) and build CacheKey from Selected so they match
export const removeEmptySelected = (queryObj: any) => {
  const selected = { ...(queryObj?.Selected || {}) };

  Object.keys(selected).forEach((key) => {
    const value = selected[key];

    if (value === '' || value == null || (Array.isArray(value) && value.length === 0)) {
      delete selected[key];
    }
  });

  const cacheKey = queryObj?.FilterKeySelected
    ? [`FilterKeySelected=${queryObj.FilterKeySelected}`, objectToQueryString(selected)].filter(Boolean).join('&')
    : queryObj?.CacheKey;

  return { ...queryObj, CacheKey: cacheKey, Selected: selected };
}
export const objectToQueryStringHaveLstObject = (obj: any, prefix = ''): string => {
  const pairs: string[] = [];

  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) continue;

    const value = obj[key];
    const prefixedKey = prefix ? `${prefix}[${key}]` : key;

    if (Array.isArray(value)) {
      value.forEach((v, i) => {
        if (typeof v === 'object' && v !== null) {
          pairs.push(objectToQueryStringHaveLstObject(v, `${prefixedKey}[${i}]`));
        } else {
          pairs.push(`${encodeURIComponent(prefixedKey)}=${encodeURIComponent(v)}`);
        }
      });
    } else if (value !== null && typeof value === 'object') {
      pairs.push(objectToQueryStringHaveLstObject(value, prefixedKey));
    } else {
      pairs.push(`${encodeURIComponent(prefixedKey)}=${encodeURIComponent(value)}`);
    }
  }
  const key = objectToCacheKey(pairs);
  return key;
};


export const objectToCacheKey = (obj: any): string => {
  const stableStringify = (o: any): string => {
    if (o !== null && typeof o === "object") {
      if (Array.isArray(o)) {
        return `[${o.map(stableStringify).join(",")}]`;
      }
      return `{${Object.keys(o).sort().map(k => `${k}:${stableStringify(o[k])}`).join(",")}}`;
    }
    return String(o);
  };

  const str = stableStringify(obj);
  return MD5(str).toString(); 
};

export const openWarningPopup = () => {
  try {
    Swal.fire({
      title: '',
      text: 'We are preparing the report, please wait...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
      willClose: () => {}
    }).then(result => {
      if (result.dismiss === Swal.DismissReason.backdrop || result.dismiss === Swal.DismissReason.esc) {
        console.warn('Popup was dismissed by user interaction');
      }
    });
  } catch (error) {
    console.error('Error opening SweetAlert2 popup:', error);
  }
}

export const closeWarningPopup = () => {
  try {
    setTimeout(() => {
      Swal.close();
    }, 1000);
  } catch (error) {
    console.log(error);
  }
};

export const getPageName = (name: string) => {
  let page = '';

  switch (name) {
    case 'VsLyBrandComponent':
    case 'VsLyCategoryComponent':
    case 'VsLyPackageComponent':
    case 'VsLySKUComponent':
    case 'VsLyTimelineComponent':
      page = 'sku-deepdive';
      break;

    case 'VsLyAreaComponent':
    case 'VsLyChannelComponent':
    case 'VsLyDealerComponent':
    case 'VsLyRouteComponent':
    case 'VsLyAreaTimelineComponent':
    case 'AreaDeepdivePage':  
      page = 'area-deepdive';
      break;

    case 'ProgressByDistrictComponent':
    case 'ProgressByRouteComponent':
    case 'DistrictTimelineComponent':
      page = 'progress-district';
      break;

    default:
      break;
  }

  return page;
}

export const isAllSelected = (arr1: any) => {
  return JSON.stringify(arr1) === JSON.stringify(['All']);
}

export const faceshareIsAllSelected = (keyName: string, arr1: any) => {
  switch (keyName) {
    case 'SALES_LOCATION_TYPE_NAME_EN':
      return JSON.stringify(arr1) === JSON.stringify(['Teiban Total']);

    default:
      return JSON.stringify(arr1) === JSON.stringify(['All']);
  }
}

export const skuSetQueryString = (lstOptionSelected: object) => {
  const analyticsQuery = {
    Selected  : {},
    UnSelected: {},
  };

  let cacheKey = '';

  if (lstOptionSelected) {
    for (const key in lstOptionSelected) {
      if (lstOptionSelected.hasOwnProperty(key)) {
        if (!isAllSelected(lstOptionSelected[key])) {
          analyticsQuery['Selected'][key] = lstOptionSelected[key];
        }
      }
    }
  }

  if (!isObjEmpty(analyticsQuery?.Selected)) {
    cacheKey += `&${objectToQueryString(analyticsQuery['Selected'])}`;
  }

  if (!isObjEmpty(analyticsQuery?.UnSelected)) {
    cacheKey += `&${objectToQueryString(analyticsQuery['UnSelected'])}`;
  }
  analyticsQuery['CacheKey'] = cacheKey;
  return analyticsQuery;
}

export const faceshareSetQueryString = (lstOptionSelected: object) => {
  const analyticsQuery = {
    Selected  : {},
    UnSelected: {},
  };

  let cacheKey = '';

  if (lstOptionSelected) {
    for (const key in lstOptionSelected) {
      if (lstOptionSelected.hasOwnProperty(key)) {
        if (!faceshareIsAllSelected(key, lstOptionSelected[key])) {
          analyticsQuery['Selected'][key] = lstOptionSelected[key];
        }
      }
    }
  }

  if (!isObjEmpty(analyticsQuery?.Selected)) {
    cacheKey += `&${objectToQueryString(analyticsQuery['Selected'])}`;
  }

  if (!isObjEmpty(analyticsQuery?.UnSelected)) {
    cacheKey += `&${objectToQueryString(analyticsQuery['UnSelected'])}`;
  }
  analyticsQuery['CacheKey'] = cacheKey;
  return analyticsQuery;
}

export const isAppleDevice = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor;
  const platform  = navigator.platform;
  const isIOS     = /iPhone|iPad|iPod/i.test(userAgent);
  const isMac     = platform === 'MacIntel';

  return isIOS || isMac;
};
